import { Box, CircularProgress, Typography } from "@mui/material";
import { DamsColors } from "../styles/DamsColors";

interface PaginationLabelProps {
    title?: string;
    onPress?: () => void;
    isActive?: boolean;
    queryPage?: number;
}

function PaginationLabel({
    title = "",
    onPress,
    isActive = false,
    queryPage
}: Readonly<PaginationLabelProps>) {
    return (
        <Box
            height={"40px"}
            width={"40px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            borderRadius={"8px"}
            padding={0}
            margin={0}
            bgcolor={isActive ? DamsColors.Badge.Grey.background : "white"}
        >
            <button
                style={styles.numContainer}
                onClick={onPress}
            >
                <Typography>{queryPage?.toString()===title ?<CircularProgress size={10}/>: title }
                 
                </Typography>
            </button>
        </Box>
    );
}

const styles = {
    numContainer: {
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
    },
};

interface PaginationProps {
    numberOfPages: number;
    activePage: number;
    setActivePage?: (page: number) => void;
    queryPage?: number;
}


function Pagination({ numberOfPages, activePage, setActivePage,queryPage }: Readonly<PaginationProps>) {
    const renderPaginationLabels = () => {
        const labels: JSX.Element[] = [];
        if (numberOfPages <= 6) {
            for (let i = 1; i <= numberOfPages; i++) {
                labels.push(
                    <PaginationLabel
                        title={i.toString()}
                        key={`pag-${i}`}
                        onPress={() => setActivePage && setActivePage(i)}
                        isActive={i === activePage}
                        queryPage={queryPage}
                    />
                );
            }
        } else {
            const startPages = [1, 2, 3];
            const endPages = [numberOfPages - 2, numberOfPages - 1, numberOfPages];
            const middlePages = [activePage - 1, activePage, activePage + 1].filter(
                (page) => page > 3 && page < numberOfPages - 2
            );

            if (activePage <= 3) {
                renderStartAndEndPages(labels, startPages, endPages, activePage, setActivePage);
            } else if (activePage >= numberOfPages - 2) {
                startPages.forEach((page) => {
                    labels.push(
                        <PaginationLabel
                            title={page.toString()}
                            key={`pag-${page}`}
                            onPress={() => setActivePage && setActivePage(page)}
                            isActive={page === activePage}
                            queryPage={queryPage}
                        />
                    );
                });
                labels.push(<Typography key="dots">...</Typography>);
                endPages.forEach((page) => {
                    labels.push(
                        <PaginationLabel
                            title={page.toString()}
                            key={`pag-${page}`}
                            onPress={() => setActivePage && setActivePage(page)}
                            isActive={page === activePage}
                            queryPage={queryPage}
                        />
                    );
                });
            } else {
                labels.push(
                    <PaginationLabel
                        title="1"
                        key="pag-1"
                        onPress={() => setActivePage && setActivePage(1)}
                        isActive={1 === activePage}
                        queryPage={queryPage}
                    />
                );
                labels.push(<Typography key="dots-start">...</Typography>);
                middlePages.forEach((page) => {
                    labels.push(
                        <PaginationLabel
                            title={page.toString()}
                            key={`pag-${page}`}
                            onPress={() => setActivePage && setActivePage(page)}
                            isActive={page === activePage}
                            queryPage={queryPage}
                        />
                    );
                });
                labels.push(<Typography key="dots-end">...</Typography>);
                endPages.forEach((page) => {
                    labels.push(
                        <PaginationLabel
                            title={page.toString()}
                            key={`pag-${page}`}
                            onPress={() => setActivePage && setActivePage(page)}
                            isActive={page === activePage}
                            queryPage={queryPage}
                        />
                    );
                });
            }
        }
        return labels;
    };

    return <>{renderPaginationLabels()}</>;
}

export { PaginationLabel, Pagination };


function renderStartAndEndPages(labels: JSX.Element[], startPages: number[], endPages: number[], activePage: number, setActivePage?: (page: number) => void, queryPage?:number) {
    startPages.forEach((page) => {
        labels.push(
            <PaginationLabel
                title={page.toString()}
                key={`pag-${page}`}
                onPress={() => setActivePage && setActivePage(page)}
                isActive={page === activePage}
                queryPage={queryPage}
            />
        );
    });
    labels.push(<Typography key="dots">...</Typography>);
    endPages.forEach((page) => {
        labels.push(
            <PaginationLabel
                title={page.toString()}
                key={`pag-${page}`}
                onPress={() => setActivePage && setActivePage(page)}
                isActive={page === activePage}
                queryPage={queryPage}
            />
        );
    });
}
